{
    "appError.goHome": "Zurück",
    "article.teaser_type_section": "Teaser-Typ",
    "comment.update_button": "Aktualisieren",
    "comment_feedback.only_visible_to_you": "Nur für Sie sichtbar",
    "comment_slider.public_response": "Für alle sichtbar",
    "comment_slider_editable_positions.heading": "Optionen beim Kommentar-Regler anpassen",
    "community_guidelines.title": "Netichette",
    "dialogue.recording_vote": "Ihre Stimme ist registriert worden",
    "dialogue.skip_submit_vote": "Überspringen und Stimme abgeben",
    "dialogue.update_response": "Aktualisieren Sie Ihre Antwort",
    "dialogue_editable_labels.heading": "Antwort-Optionen anpassen",
    "editorial_question.be_first": "Seien Sie die erste Person, die ihre Gedanken teilt",
    "error.network": "Netzwerkfehler - bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    "linked_partner_story.incomplete_list_banner": "Diese Liste von Artikeln ist möglicherweise unvollständig.",
    "linked_partner_story.linked_articles_description": "Artikel ansehen, die mit dieser Debatte verbunden sind.",
    "linked_partner_story.linked_articles_heading": "Verknüpfte Artikel",
    "linked_partner_story.no_articles_found": "Es sind noch keine Artikel mit diesem Bereich verknüpft.",
    "login.default_login_heading_label": "Ein Raum für gesunde Debatten und verschiedene Perspektiven",
    "login.okay_button": "OK",
    "login.sso_error": "Beim Anmelden ist etwas schiefgelaufen. Bitte schliessen Sie dieses Fenster und versuchen Sie es erneut.",
    "moderation.admin_filter_notice": "Um die KI-Moderation zu verbessern, senden Sie bitte ein Bildschirmfoto Ihres Beitrags und dieser Nachricht an Ihr Team.",
    "moderation.awaitingDecision": "Genehmigung ausstehend",
    "moderation.blocked": "Zurückgewiesen",
    "moderation.bypassedPremoderation": "Vormoderation umgangen",
    "moderation.dash.approve": "Genehmigen",
    "moderation.dash.base_filter._rejected": "Manuell abgelehnt",
    "moderation.dash.base_filter.approved": "Genehmigt",
    "moderation.dash.base_filter.auto_approved": "Automatisch genehmigt",
    "moderation.dash.base_filter.awaiting_decision": "Entscheid wird erwartet",
    "moderation.dash.reject": "Ablehnen",
    "moderation.info_ai_and_manual_moderation_banner_text": "Um einen respektvollen Umgang zu gewährleisten, werden alle Beiträge in diesem Bereich sowohl von KI als auch manuell moderiert, bevor sie veröffentlicht werden. Damit soll sichergestellt werden, dass sie der Netiquette entsprechen.",
    "moderation.info_manual_moderation_banner_text": "Um einen respektvollen Umgang zu gewährleisten, werden alle Beiträge in diesem Bereich manuell moderiert, bevor sie veröffentlicht werden. Damit soll sichergestellt werden, dass sie der Netiquette entsprechen.",
    "moderation.postedAnyway": "Trotzdem publiziert",
    "moderation.rejected_by_moderator": "Vom Moderationsteam abgelehnt",
    "moderation.sent_to_moderator_time": "An Moderationsteam gesendet: {time}",
    "moderation.system_unavailable_message": "Unser KI-Moderationssystem ist vorübergehend nicht verfügbar. Sie können Ihren Beitrag dennoch an unser Moderationsteam zur Überprüfung senden.",
    "moderation_card.language_tag": "{locale} | Übersetzt",
    "onboarding.dismiss_button": "Schliessen",
    "pin_to_feed.move_down": "Nach unten",
    "pin_to_feed.move_up": "Nach oben",
    "poll.result_your_vote": "{tLabel} (Ihre stimme): {percent}%",
    "popup.close_button": "Popup schliessen",
    "post.post_anyway_button": "Trotzdem publizieren",
    "post.posting_anyway": "Trotzdem publizieren...",
    "profile.edit.name_override.placeholder": "Fügen Sie Ihren gewünschten Namen hinzu...",
    "profile.edit.photo_override": "URL des Fotos",
    "profile.edit.photo_override.placeholder": "Fügen Sie Ihre gewünschte URL hinzu...",
    "profile.go_to.edit": "Änderungen bearbeiten",
    "profile.loading": "Profil wird geladen...",
    "profile.photo_label": "Ihr Profilfoto",
    "profile.username_placeholder": "Benutzer123",
    "question.actions.close_modal_description": "Wenn geschlossen, bleibt dieser Bereich lesbar. Die meisten Aktionen sind deaktiviert und Nutzende können nicht publizieren, antworten oder reagieren. Nutzende können weiterhin Kommentare melden. Sie können die Debatte jederzeit wieder öffnen.",
    "question.actions.close_modal_heading": "Diesen Bereich schliessen?",
    "question.actions.link_copied_toast": "Link in die Zwischenablage kopiert",
    "question.actions.linked_stories_button": "Verknüpfte Artikel",
    "question.conversation_format": "Debattenformat",
    "question.conversation_type_section": "Debattentyp",
    "question.error_empty_prompt": "Dieses Feld darf nicht leer sein.",
    "question.error_prompt_too_long": "Dieses Feld muss weniger als {num} Zeichen umfassen.",
    "question.no_comments_message": "Seien Sie die erste Person, die ihre Gedanken teilt",
    "question.no_comments_title": "Beginnen Sie die Unterhaltung",
    "question.prosocial_ranking_section": "Ranking der Reaktionen",
    "question.public_response_subtitle": "Publizierter Beitrag",
    "question.reaction_plural": "Reaktionen",
    "question.reaction_singular": "Reaktion",
    "question.reply_placeholder": "Antworten Sie {authorName}...",
    "question.upvote_plural": "Stimmen dafür",
    "reaction_types.appreciation_plural": "Likes",
    "reaction_types.appreciation_singular": "Like ",
    "reaction_types.fun_space": "Spass-Raum",
    "reaction_types.insightful": "Vertiefend",
    "reaction_types.personal_space": "Persönlicher Raum",
    "related_content.learn_more": "Erfahren Sie mehr zu diesem Thema",
    "related_conversations.no_spaces_found": "Keine Räume gefunden",
    "single_response_help.same_question_title": "Gleiche Frage, anderer Inhalt?",
    "space.detail.id": "ID:",
    "space.detail.posts": "Posts:",
    "standalone_question.participant": "Teilnehmer/-innen",
    "standalone_question.participants": "Teilnehmer/-innen",
    "story_dash.date_column": "Veröffentlicht",
    "survey.feedback_help": "Ihr Feedback wird uns helfen, Ihre Erfahrung zu verbessern.",
    "survey.tell_us_experience": "Erzählen Sie uns von Ihrer Erfahrung",
    "survey.thank_you": "Vielen Dank, dass Sie Ihre Erfahrung mit uns geteilt haben!",
    "upvote.aria_label": "Dafür stimmen"
}
